import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

/**
 * GET /miva/collections
 */
export async function getMivaCollections(
  client: RedoMerchantClient,
  {
    searchString,
    signal,
  }: { searchString: string | undefined; signal?: AbortSignal },
): Promise<{ id: number; name: string }[]> {
  const params = new URLSearchParams();
  if (searchString) {
    params.set("search", searchString);
  }
  const response = await client.client.get("/miva/collections", {
    params,
    signal,
    headers: client.authorization(),
  });
  return response.data;
}
